export const Issuer = {
  JWT: "JWT"
};
